import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { useHistory } from 'react-router-dom'
import {
  addMinutes,
  isFuture,
  isPast,
  subMinutes,
  formatDistanceToNow,
  differenceInMinutes,
} from 'date-fns'
import sessionTypes from 'utils/sessionTypes.json'

import styles from './DashboardReminder.module.scss'

import { callApi, strikesApi } from 'api'

const DashboardReminder = ({ calls, events, user }) => {
  const history = useHistory()
  const [combinedList, setCombinedList] = useState()
  const [isClosingRoom, setIsClosingRoom] = useState(false)
  const [closedInstantRoomId, setClosedInstantRoomId] = useState(null)

  useEffect(() => {
    if (calls && events) {
      setCombinedList([...calls, ...events])?.sort(
        (a, b) => new Date(a.scheduled_at) - new Date(b.scheduled_at)
      )
    }
  }, [events, calls])

  const checkTimeHasCome = (call) => {
    return (
      isFuture(addMinutes(new Date(call?.scheduled_at), 15)) &&
      isPast(subMinutes(new Date(call?.scheduled_at), 15))
    )
  }

  const latestCall = combinedList?.filter((call) => {
    return (
      call.id !== closedInstantRoomId &&
      ((!call.canceled &&
        isFuture(addMinutes(new Date(call?.scheduled_at), 15)) &&
        isPast(subMinutes(new Date(call?.scheduled_at), 15)) &&
        !call.declined &&
        !call.finished_at) ||
        (call.started_at &&
          !call.finished_at &&
          isFuture(addMinutes(new Date(call?.scheduled_at), 15)) &&
          isPast(subMinutes(new Date(call?.scheduled_at), 15))))
    )
  })[0]

  const handleClickBtn = () => {
    if (latestCall.payment_id === 'instant_free') {
      history.push(`/${latestCall?.pro?.channel_name}/room`)
      return
    }

    if (checkTimeHasCome(latestCall) && latestCall?.call_request) {
      history.push(`/talk/${latestCall?.call_request}`, latestCall)
    } else if (checkTimeHasCome(latestCall) && latestCall?.title) {
      history.push(`/event/${latestCall?.id}`, latestCall)
    }
  }

  useEffect(() => {
    if (!latestCall?.id || !latestCall?.scheduled_at) return

    // Send one auto-report at most once per call and only after 15 minutes late.
    const reportStorageKey = `late-call-report:${latestCall.id}`
    const alreadyReported = window.sessionStorage.getItem(reportStorageKey)
    if (alreadyReported) return

    if (!isPast(addMinutes(new Date(latestCall.scheduled_at), 15))) return

    strikesApi
      .sendReport({
        user: latestCall?.pro,
        client: latestCall?.client,
        pro: latestCall?.pro,
        title: 'Late for call',
        description: 'More than 15 minutes late for call',
        call_id: latestCall?.id,
      })
      .then((res) => {
        if (!res?.error) {
          window.sessionStorage.setItem(reportStorageKey, '1')
        }
      })
  }, [latestCall])

  const companionName = latestCall?.title
    ? latestCall?.pro?.user?.name
    : latestCall?.client?.user?.name
  const scheduledAt = latestCall?.scheduled_at

  const closeMeetingRoom = async () => {
    if (!user?.channel_name || isClosingRoom) return

    setIsClosingRoom(true)

    try {
      const activeInstantCallRes = await callApi.getActiveInstantCall(user.channel_name)
      const activeInstantCallId = activeInstantCallRes?.result?.id

      if (!activeInstantCallId) {
        setIsClosingRoom(false)
        return
      }

      const endCallRes = await callApi.endGroupCall({ id: activeInstantCallId })

      if (!endCallRes?.error) {
        setClosedInstantRoomId(latestCall?.id || activeInstantCallId)
      }
    } catch {
      // Keep current UI state on error.
    } finally {
      setIsClosingRoom(false)
    }
  }

  return (
    <>
      {companionName && scheduledAt && (
        <div className={styles.dashboardReminder}>
          <div className={styles.dashboardReminderIn}>
            {isPast(new Date(latestCall?.scheduled_at), 15) ? (
              <>
                <div
                  className={`${styles.dashboardReminderContent} ${styles.dashboardReminderContentStarted}`}
                  onClick={
                    differenceInMinutes(new Date(scheduledAt), new Date(), 'ceil') < 15
                      ? handleClickBtn
                      : undefined
                  }
                  style={
                    differenceInMinutes(new Date(scheduledAt), new Date(), 'ceil') < 15
                      ? { cursor: 'pointer' }
                      : {}
                  }
                >
                  {latestCall?.title
                    ? `Your ${sessionTypes[user?.category].toLowerCase()} started ${' '}`
                    : `Call with ${companionName} started ${' '}`}
                  {formatDistanceToNow(new Date(scheduledAt))} ago
                </div>
                {latestCall?.payment_id === 'instant_free' && (
                  <button
                    type="button"
                    className={styles.dashboardReminderLink}
                    onClick={closeMeetingRoom}
                    disabled={isClosingRoom}
                  >
                    {isClosingRoom ? 'Closing...' : 'Close'}
                  </button>
                )}
              </>
            ) : (
              <>
                <div
                  className={styles.dashboardReminderContent}
                  onClick={
                    differenceInMinutes(new Date(scheduledAt), new Date(), 'ceil') < 15
                      ? handleClickBtn
                      : undefined
                  }
                  style={
                    differenceInMinutes(new Date(scheduledAt), new Date(), 'ceil') < 15
                      ? { cursor: 'pointer' }
                      : {}
                  }
                >
                  Next call starts in {formatDistanceToNow(new Date(scheduledAt))}
                </div>
              </>
            )}
          </div>
        </div>
      )}
    </>
  )
}

const mapStateToProps = ({ auth: { error, isPro, user, calls, events } }) => ({
  authError: error,
  calls,
  user,
  isPro,
  events,
})

export default connect(mapStateToProps)(DashboardReminder)
